<template>
    <span>
        <template v-if="icon">
            <svg-icon :type="symbol.icon" :size="size" />
        </template>
        <template v-else>{{ symbol.sign }}</template>
    </span>
</template>

<script>
import SvgIcon from './ui/SvgIcon.vue';
import {mapStores} from "pinia";
import {useCurrencyStore} from "../state/modules/currency";

export default {
    components: {
        SvgIcon,
    },
    props: {
        icon: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: '16',
        },
    },
    computed: {
        ...mapStores(useCurrencyStore),
        symbol() { return this.currencyStore.symbol }
    },
    mounted() {
        if (!this.symbol || this.symbol.length == 0) {
            this.currencyStore.fetch();
        }
    },
}
</script>
